/* istanbul ignore file */
import React from 'react';

export const BlockCommunityPreview = React.lazy(async () => {
    const { BlockCommunityPreview } = await import(
        /* webpackChunkName: 'block-community-preview' */
        './BlockCommunityPreview'
    );
    return { default: BlockCommunityPreview };
});
